import type { ApiResponse } from "@/types";

import { BaseApi } from "../base.api";
import type { Lecture, UpsertLectureData } from "./types";

export * from "./types";

/** Ma'ruza kontenti API — backend'dagi `LecturesController` ning ko'zgusi. */
export class LecturesApi extends BaseApi {
  private url(lessonId: number): string {
    return `/lessons/${lessonId}/lecture`;
  }

  /**
   * Darsning ma'ruza kontenti. Hali yaratilmagan bo'lsa backend 404 qaytaradi —
   * bu kutilgan holat, shuning uchun xato toast'i o'chirilgan.
   */
  getByLesson(lessonId: number) {
    return this.request.get<Lecture, ApiResponse<Lecture>>(this.url(lessonId), {
      skipErrorToast: true,
    });
  }

  upsert(lessonId: number, data: UpsertLectureData) {
    return this.request.put<Lecture, ApiResponse<Lecture>>(this.url(lessonId), data);
  }

  uploadVideo(lessonId: number, file: File, onProgress?: (percent: number) => void) {
    const formData = new FormData();
    formData.append("video", file);
    return this.request.post<Lecture, ApiResponse<Lecture>>(
      `${this.url(lessonId)}/video`,
      formData,
      {
        onUploadProgress: event => {
          if (onProgress && event.total) {
            onProgress(Math.round((event.loaded * 100) / event.total));
          }
        },
      },
    );
  }

  addAttachments(lessonId: number, files: File[], onProgress?: (percent: number) => void) {
    const formData = new FormData();
    files.forEach(file => formData.append("files", file));
    return this.request.post<Lecture, ApiResponse<Lecture>>(
      `${this.url(lessonId)}/attachments`,
      formData,
      {
        onUploadProgress: event => {
          if (onProgress && event.total) {
            onProgress(Math.round((event.loaded * 100) / event.total));
          }
        },
      },
    );
  }

  remove(lessonId: number) {
    return this.request.delete<null, ApiResponse<null>>(this.url(lessonId));
  }
}

export const lecturesApi = new LecturesApi();
